/**
 * BUSINESS LOGIC: TOMBOLA (LIVE BADGE) & CONTACTO (WHATSAPP) OVERLAY
 */
import { 
    GetTombolaConfig as DLGetTombolaConfig,
    SetTombolaConfig as DLSetTombolaConfig,
    ShowTombolaOverlay as DLShowTombolaOverlay,
    HideTombolaOverlay as DLHideTombolaOverlay,
    GetContactoConfig as DLGetContactoConfig,
    SetContactoConfig as DLSetContactoConfig,
    ShowContactoOverlay as DLShowContactoOverlay,
    HideContactoOverlay as DLHideContactoOverlay,
    CreateContactoItem as DLCreateContactoItem,
    UpdateContactoItem as DLUpdateContactoItem,
    DeleteContactoItem as DLDeleteContactoItem,
    SelectContactoItem as DLSelectContactoItem,
    ToggleContactoVisibility as DLToggleContactoVisibility,
    GetPortadaConfig as DLGetPortadaConfig,
    SetPortadaConfig as DLSetPortadaConfig,
    ShowPortadaOverlay as DLShowPortadaOverlay,
    HidePortadaOverlay as DLHidePortadaOverlay,
    GetSoporteConfig as DLGetSoporteConfig,
    SetSoporteConfig as DLSetSoporteConfig,
    ShowSoporteOverlay as DLShowSoporteOverlay,
    HideSoporteOverlay as DLHideSoporteOverlay,
    GetCumpleanosConfig as DLGetCumpleanosConfig,
    SetCumpleanosConfig as DLSetCumpleanosConfig,
    ShowCumpleanosOverlay as DLShowCumpleanosOverlay,
    HideCumpleanosOverlay as DLHideCumpleanosOverlay,
    CreateLiveBadgeItem as DLCreateLiveBadgeItem,
    UpdateLiveBadgeItem as DLUpdateLiveBadgeItem,
    DeleteLiveBadgeItem as DLDeleteLiveBadgeItem,
    SelectLiveBadgeItem as DLSelectLiveBadgeItem,
    ToggleLiveBadgeLogo as DLToggleLiveBadgeLogo
} from './../DL/Tombola'

export const GetTombolaConfig = async () => {
    return await DLGetTombolaConfig();
};

export const SetTombolaConfig = async (config) => {
    // Validar datos antes de enviarlos
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.speed < 0.1) config.speed = 0.1;
    if (config.glow < 0) config.glow = 0;
    if (config.offsetX < -1920) config.offsetX = -1920;
    if (config.offsetY < -1080) config.offsetY = -1080;
    if (config.offsetX > 1920) config.offsetX = 1920;
    if (config.offsetY > 1080) config.offsetY = 1080;
    if (!config.position) config.position = "center";

    return await DLSetTombolaConfig(config);
};

export const ShowTombolaOverlay = async () => {
    return await DLShowTombolaOverlay();
};

export const HideTombolaOverlay = async () => {
    return await DLHideTombolaOverlay();
};

// Contacto BL methods
export const GetContactoConfig = async () => {
    return await DLGetContactoConfig();
};

export const SetContactoConfig = async (config) => {
    // Validar datos
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.iconZoom < 0.1) config.iconZoom = 0.1;
    if (config.borderWidth < 0) config.borderWidth = 0;
    if (config.offsetX < -1920) config.offsetX = -1920;
    if (config.offsetY < -1080) config.offsetY = -1080;
    if (config.offsetX > 1920) config.offsetX = 1920;
    if (config.offsetY > 1080) config.offsetY = 1080;
    if (!config.position) config.position = "center";

    return await DLSetContactoConfig(config);
};

export const ShowContactoOverlay = async () => {
    return await DLShowContactoOverlay();
};

export const HideContactoOverlay = async () => {
    return await DLHideContactoOverlay();
};

export const CreateContactoItem = async (item) => {
    return await DLCreateContactoItem(item);
};

export const UpdateContactoItem = async (id, item) => {
    return await DLUpdateContactoItem(id, item);
};

export const DeleteContactoItem = async (id) => {
    return await DLDeleteContactoItem(id);
};

export const SelectContactoItem = async (id) => {
    return await DLSelectContactoItem(id);
};

export const ToggleContactoVisibility = async (visible) => {
    return await DLToggleContactoVisibility(visible);
};

// Portada BL methods
export const GetPortadaConfig = async () => {
    return await DLGetPortadaConfig();
};

export const SetPortadaConfig = async (config) => {
    if (config.scale < 0.1) config.scale = 0.1;
    return await DLSetPortadaConfig(config);
};

export const ShowPortadaOverlay = async () => {
    return await DLShowPortadaOverlay();
};

export const HidePortadaOverlay = async () => {
    return await DLHidePortadaOverlay();
};

// Soporte BL methods
export const GetSoporteConfig = async () => {
    return await DLGetSoporteConfig();
};

export const SetSoporteConfig = async (config) => {
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.speed < 0.1) config.speed = 0.1;
    if (config.glow < 0) config.glow = 0;
    if (config.offsetX < -1920) config.offsetX = -1920;
    if (config.offsetY < -1080) config.offsetY = -1080;
    if (config.offsetX > 1920) config.offsetX = 1920;
    if (config.offsetY > 1080) config.offsetY = 1080;
    if (!config.position) config.position = "center";
    return await DLSetSoporteConfig(config);
};

export const ShowSoporteOverlay = async () => {
    return await DLShowSoporteOverlay();
};

export const HideSoporteOverlay = async () => {
    return await DLHideSoporteOverlay();
};

// Cumpleanos BL methods
export const GetCumpleanosConfig = async () => {
    return await DLGetCumpleanosConfig();
};

export const SetCumpleanosConfig = async (config) => {
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.offsetX < 0) config.offsetX = 0;
    if (config.offsetY < 0) config.offsetY = 0;
    if (config.offsetX > 100) config.offsetX = 100;
    if (config.offsetY > 100) config.offsetY = 100;
    if (!config.position) config.position = "center";
    return await DLSetCumpleanosConfig(config);
};

export const ShowCumpleanosOverlay = async () => {
    return await DLShowCumpleanosOverlay();
};

export const HideCumpleanosOverlay = async () => {
    return await DLHideCumpleanosOverlay();
};

export const CreateLiveBadgeItem = async (item) => {
    return await DLCreateLiveBadgeItem(item);
};

export const UpdateLiveBadgeItem = async (id, item) => {
    return await DLUpdateLiveBadgeItem(id, item);
};

export const DeleteLiveBadgeItem = async (id) => {
    return await DLDeleteLiveBadgeItem(id);
};

export const SelectLiveBadgeItem = async (id) => {
    return await DLSelectLiveBadgeItem(id);
};

export const ToggleLiveBadgeLogo = async (id) => {
    return await DLToggleLiveBadgeLogo(id);
};

